import styled from "styled-components";
import theme from "../../../styles/theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  width: 100vw;
  overflow-y: auto;
  /* height: 100vh; */
`;
export const TopContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-top: 4vh;
  align-items: center;
  @media ${theme.devices.tablet} {
    flex-direction: column;
  }
`;
export const LogoImg = styled.img`
  height: 7vh;
  margin-left: 7vw;
  @media ${theme.devices.tablet} {
    margin-left: 0vw;
  }
`;

export const BtnContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .btn {
    width: fit-content;
    margin-right: 7vw;
    @media ${theme.devices.tablet} {
      width: 85%;
      margin-right: 0vw;
      margin-top: 1vh;
    }
  }
  @media ${theme.devices.tablet} {
    flex-direction: column;
  }
`;
